import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const MemberAnalyticsPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to new member dashboard with analytics tab
    navigate('/member?tab=analytics', { replace: true });
  }, [navigate]);

  return (
    <div className="analytics-page">
      <div className="analytics-page__redirecting">
        <p>重新導向至新的會員中心...</p>
      </div>
    </div>
  );
};

export default MemberAnalyticsPage;
